import { ChangeEvent, CSSProperties, useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";

interface Props {
  className?: string;
  inputClassName?: string;
  inputStyle?: CSSProperties;
  defaultValue?: string;
  name?: string;
  type?: "text" | "number";
  prefix?: string;
  onBeforeChange?: (...args: any) => void;
  onAfterChange?: (...args: any) => void;
}

export default function ToggleInput({
  className,
  inputClassName,
  inputStyle,
  defaultValue = "",
  name,
  type = "text",
  prefix = "",
  onBeforeChange,
  onAfterChange,
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");
  const [enable, setEnable] = useState(false);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;
    input.value = defaultValue;
    setValue(defaultValue);
  }, [defaultValue]);

  const onStart = () => {
    onBeforeChange?.();
    setEnable(true);
    setTimeout(() => {
      inputRef.current?.focus();
    });
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
  };

  const onFinish = () => {
    if (value) {
      onAfterChange?.(value);
    } else {
      const input = inputRef.current;
      if (input) input.value = defaultValue;
      setValue(defaultValue);
    }
    setEnable(false);
  };

  return (
    <div
      className={`${styles["field"]} flex items-center ${className}`}
      onDoubleClick={onStart}
    >
      <span>{prefix}</span>
      <input
        ref={inputRef}
        className={`${enable ? "" : "pointer-events-none"} text-md h-full w-full p-2 ${inputClassName}`}
        style={inputStyle}
        name={name}
        type={type}
        onBlur={onFinish}
        onChange={onChange}
        onKeyDown={(event) => {
          if (event.key === "Enter") inputRef.current?.blur();
        }}
      />
    </div>
  );
}
